import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            来看看其他吃瓜群众怎么说
          </p>
        </div>
        <div className="space-y-4">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800">{item.user}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-2">{item.text}</p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      {item.likes}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}